<main class="knowledge-page h-full min-h-[760px] w-full min-w-0 overflow-hidden bg-app text-ink">
  @if (selectedBase(); as base) {
      <app-ui-page-header
        class="knowledge-titlebar"
        [title]="base.name"
        [subtitle]="base.description || selectedBaseTypeOption()?.description || ''"
        density="compact"
        [divider]="false"
      >
        <div actions class="knowledge-titlebar__actions">
          <button appButton variant="ghost" size="sm" type="button" (click)="closeBase()" aria-label="Voltar para bibliotecas">
            <ng-icon name="heroArrowLeft" size="17" aria-hidden="true" />
            Voltar
          </button>
          <button
            appSwitch
            class="status-toggle-card"
            [attr.aria-label]="base.status === 'active' ? 'Desativar biblioteca' : 'Ativar biblioteca'"
            [attr.title]="base.status !== 'active' && activeDocumentCount() < 5 ? 'É preciso ter ao menos 5 documentos ativos para ativar.' : null"
            [ngpSwitchChecked]="base.status === 'active'"
            [ngpSwitchDisabled]="base.status !== 'active' && activeDocumentCount() < 5"
            (ngpSwitchCheckedChange)="setSelectedBaseActive($event)"
          >
            <span class="status-toggle-track" aria-hidden="true">
              <span appSwitchThumb></span>
            </span>
            <span>{{ base.status === 'active' ? 'Ativa' : 'Inativa' }}</span>
          </button>
          <button appButton variant="secondary" type="button" (click)="refreshCurrentView()" [disabled]="loadingBases() || loadingDetail()">
            <ng-icon name="heroArrowPath" size="16" aria-hidden="true" />
            Atualizar
          </button>
        </div>
      </app-ui-page-header>
    } @else {
      <app-ui-page-header
        class="knowledge-titlebar"
        title="Bibliotecas de conhecimento"
        subtitle="Bases operacionais que transformam fontes em documentos recuperáveis por agentes."
        [count]="bases().length"
        density="compact"
        [divider]="false"
      >
        <div actions class="knowledge-titlebar__actions">
          <div class="toggle-shell toggle-shell--view">
            <div
              class="library-view-toggle"
              layout="segmented"
              [columns]="2"
              appIconToggleGroup
              ngpToggleGroupType="single"
              aria-label="Visualização das bibliotecas"
              [ngpToggleGroupValue]="libraryViewValue()"
              (ngpToggleGroupValueChange)="setLibraryViewValue($event)"
            >
              <span
                appIconToggleIndicator
                [columns]="2"
                [class.translate-x-0]="libraryView() === 'grid'"
                [class.translate-x-full]="libraryView() === 'list'"
                aria-hidden="true"
              ></span>
              <button
                type="button"
                aria-label="Visualização em cartões"
                appIconToggleGroupItem
                ngpToggleGroupItemValue="grid"
              >
                <ng-icon class="text-current" name="heroSquares2x2" size="18" aria-hidden="true" />
                <span class="sr-only">Cartões</span>
              </button>
              <button
                type="button"
                aria-label="Visualização em lista"
                appIconToggleGroupItem
                ngpToggleGroupItemValue="list"
              >
                <ng-icon class="text-current" name="heroListBullet" size="18" aria-hidden="true" />
                <span class="sr-only">Lista</span>
              </button>
            </div>
          </div>
          <button appButton variant="primary" type="button" (click)="toggleBaseCreation()">
            <ng-icon name="heroPlus" size="16" aria-hidden="true" />
            Nova biblioteca
          </button>
          <button appButton variant="secondary" type="button" (click)="refreshCurrentView()" [disabled]="loadingBases() || loadingDetail()">
            <ng-icon name="heroArrowPath" size="16" aria-hidden="true" />
            Atualizar
          </button>
        </div>
      </app-ui-page-header>
    }

  @if (!selectedBase()) {
    <section class="library-home overflow-y-auto">
      @if (creatingBase()) {
        <section appUiPanelCard class="create-base-panel" aria-label="Nova biblioteca">
          <div class="section-heading">
            <div>
              <span appUiLabel class="uppercase">Nova biblioteca</span>
              <h2>Criar base de conhecimento</h2>
            </div>
            <button appButton variant="ghost" size="sm" type="button" (click)="toggleBaseCreation()">
              <ng-icon name="heroXMark" size="16" aria-hidden="true" />
              Fechar
            </button>
          </div>

          <div class="create-base-layout">
            <div class="base-type-grid" role="group" aria-label="Tipo da biblioteca">
              @for (option of typeOptions; track option.value) {
                <button
                  appUiOptionRow
                  tall
                  type="button"
                  [selected]="baseType() === option.value"
                  (click)="chooseBaseType(option.value)"
                >
                  <span appUiOptionRowIcon>
                    <ng-icon [name]="option.icon" size="18" aria-hidden="true" />
                  </span>
                  <span appUiOptionRowCopy>
                    <strong>{{ option.label }}</strong>
                    <small>{{ option.description }}</small>
                  </span>
                </button>
              }
            </div>

            <div class="base-form">
              <label>
                <span appUiLabel class="mb-2 block uppercase">Nome</span>
                <input appInput type="text" [value]="baseName()" (input)="setSignal(baseName, $event)" placeholder="Ex.: FAQ de atendimento" />
              </label>
              <label>
                <span appUiLabel class="mb-2 block uppercase">Descrição</span>
                <textarea
                  appTextarea
                  rows="4"
                  [value]="baseDescription()"
                  (input)="setSignal(baseDescription, $event)"
                  placeholder="Escopo, público e limites desta biblioteca."
                ></textarea>
              </label>
              <div class="form-actions">
                <button appButton variant="secondary" type="button" (click)="toggleBaseCreation()">Cancelar</button>
                <button appButton variant="primary" type="button" (click)="createBase()" [disabled]="savingBase() || !canCreateBase()">
                  @if (savingBase()) {
                    Criando...
                  } @else {
                    Criar e abrir
                  }
                </button>
              </div>
            </div>
          </div>
        </section>
      }

      @if (loadingBases() && bases().length === 0) {
        <div class="library-grid" aria-label="Carregando bibliotecas">
          @for (item of [1, 2, 3, 4, 5, 6]; track item) {
            <app-ui-skeleton-row [height]="144" />
          }
        </div>
      } @else if (bases().length === 0) {
        <app-ui-empty-state
          icon="heroFolderOpen"
          title="Nenhuma biblioteca encontrada"
          description="Crie a primeira biblioteca para conectar fontes, documentos e recuperação."
        >
          <button actions appButton variant="primary" type="button" (click)="toggleBaseCreation()">
            <ng-icon name="heroPlus" size="16" aria-hidden="true" />
            Nova biblioteca
          </button>
        </app-ui-empty-state>
      } @else {
        @if (libraryView() === 'grid') {
          <app-ui-resource-grid minColumnWidth="17rem" aria-label="Bibliotecas disponíveis">
            @for (base of bases(); track base.id) {
              <app-ui-resource-card minHeight="10rem">
                <div appUiResourceCardHeader>
                  <span class="library-icon">
                    <ng-icon [name]="typeIcon(base.type)" size="22" aria-hidden="true" />
                  </span>
                  <span appBadge [tone]="baseStatusTone(base.status)" size="xs">{{ baseStatusLabel(base.status) }}</span>
                </div>
                <div appUiResourceCardBody>
                  <button appUiRecordRowButton type="button" class="library-card-title-button" (click)="openBase(base)">
                    <h3 appUiResourceCardTitle>{{ base.name }}</h3>
                  </button>
                  <p appUiResourceCardEyebrow>{{ typeLabel(base.type) }}</p>
                  @if (base.description) {
                    <p appUiResourceCardDescription>{{ base.description }}</p>
                  }
                </div>
                <div appUiResourceCardFooter [separated]="true">
                  <div class="library-card-stats">
                    <span aria-label="Documentos ativos">
                      <ng-icon name="heroDocumentText" size="14" aria-hidden="true" />
                      {{ libraryActiveDocumentCount(base) }}
                    </span>
                    <span aria-label="Fontes vinculadas">
                      <ng-icon name="heroCloudArrowUp" size="14" aria-hidden="true" />
                      {{ librarySourceCount(base) }}
                    </span>
                  </div>
                  <button
                    appButton
                    variant="ghost"
                    size="sm"
                    type="button"
                    [disabled]="isArchivingBase(base.id)"
                    (click)="archiveBase(base)"
                    [attr.aria-label]="'Excluir biblioteca ' + base.name"
                  >
                    <ng-icon name="heroTrash" size="14" aria-hidden="true" />
                    Excluir
                  </button>
                </div>
              </app-ui-resource-card>
            }
          </app-ui-resource-grid>
        } @else {
          <div appUiDataTableShell class="overflow-x-auto">
            <table appUiDataTable appUiResizableColumns key="knowledge-bases">
              <thead appUiDataTableHead>
                <tr>
                  <th appUiDataTableHeaderCell>Biblioteca</th>
                  <th appUiDataTableHeaderCell>Tipo</th>
                  <th appUiDataTableHeaderCell class="text-right">Documentos</th>
                  <th appUiDataTableHeaderCell class="text-right">Fontes</th>
                  <th appUiDataTableHeaderCell class="text-right">Status</th>
                  <th appUiDataTableHeaderCell class="w-px whitespace-nowrap text-right" data-no-resize>Ações</th>
                </tr>
              </thead>
              <tbody>
                @for (base of bases(); track base.id) {
                  <tr appUiDataTableRow>
                    <td appUiDataTableCell>
                      <button appUiRecordRowButton type="button" class="library-row__button" (click)="openBase(base)">
                        <span class="library-icon">
                          <ng-icon [name]="typeIcon(base.type)" size="18" aria-hidden="true" />
                        </span>
                        <span class="library-row__title">{{ base.name }}</span>
                      </button>
                    </td>
                    <td appUiDataTableCell>{{ typeLabel(base.type) }}</td>
                    <td appUiDataTableCell class="text-right" aria-label="Documentos ativos">
                      <span class="library-row__count">
                        <ng-icon name="heroDocumentText" size="14" aria-hidden="true" />
                        {{ libraryActiveDocumentCount(base) }}
                      </span>
                    </td>
                    <td appUiDataTableCell class="text-right" aria-label="Fontes vinculadas">
                      <span class="library-row__count">
                        <ng-icon name="heroCloudArrowUp" size="14" aria-hidden="true" />
                        {{ librarySourceCount(base) }}
                      </span>
                    </td>
                    <td appUiDataTableCell class="text-right">
                      <span appBadge [tone]="baseStatusTone(base.status)" size="xs">{{ baseStatusLabel(base.status) }}</span>
                    </td>
                    <td appUiDataTableCell class="w-px whitespace-nowrap text-right">
                      <button
                        appButton
                        variant="ghost"
                        size="sm"
                        type="button"
                        [disabled]="isArchivingBase(base.id)"
                        (click)="archiveBase(base)"
                        [attr.aria-label]="'Excluir biblioteca ' + base.name"
                      >
                        <ng-icon name="heroTrash" size="14" aria-hidden="true" />
                        Excluir
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      }
    </section>
  } @else {
    <section class="library-detail min-h-0 overflow-y-auto" aria-label="Detalhe da biblioteca">
      <section class="workspace-grid">
        <div class="workspace-main">
          <section appUiPanelCard class="content-panel content-panel--primary" aria-label="Documentos">
            <div class="section-heading">
              <div>
                <h2>Documentos</h2>
              </div>
              <span appBadge tone="neutral" size="xs">{{ filteredDocumentViews().length }} de {{ selectedDocuments().length }}</span>
            </div>

            <div class="document-toolbar">
              <button
                appSelect
                type="button"
                [ngpSelectValue]="documentStatusFilter()"
                (ngpSelectValueChange)="setDocumentStatusFilter($event)"
                aria-label="Filtrar por status"
              >
                <span>{{ documentStatusFilterLabel() }}</span>
                <div *ngpSelectPortal appSelectDropdown>
                  @for (option of documentStatusFilters; track option.value) {
                    <div appSelectOption [ngpSelectOptionValue]="option.value">{{ option.label }}</div>
                  }
                </div>
              </button>

              <button
                appSelect
                type="button"
                [ngpSelectValue]="documentSourceFilter()"
                (ngpSelectValueChange)="setDocumentSourceFilter($event)"
                aria-label="Filtrar por fonte"
              >
                <span class="truncate">{{ documentSourceFilterLabel() }}</span>
                <div *ngpSelectPortal appSelectDropdown>
                  @for (option of documentSourceOptions(); track option.value) {
                    <div appSelectOption [ngpSelectOptionValue]="option.value">{{ option.label }}</div>
                  }
                </div>
              </button>
            </div>

            @if (loadingDetail()) {
              <div class="grid gap-2">
                @for (item of [1, 2, 3]; track item) {
                  <app-ui-skeleton-row [height]="112" />
                }
              </div>
            } @else if (filteredDocumentViews().length === 0) {
              <app-ui-empty-state
                icon="heroDocumentText"
                title="Nenhum documento encontrado"
                description="Ajuste os filtros ou insira uma nova fonte para gerar documentos."
              />
            } @else {
              <div class="document-list">
                @for (view of filteredDocumentViews(); track view.document.id) {
                  <article appUiRecordRow [interactive]="false" class="document-row">
                    <div class="document-row__header">
                      <div class="document-title-block">
                        <div class="row-title">
                          <button
                            appCheckbox
                            [ngpCheckboxChecked]="isDocumentSelected(view.document.id)"
                            (ngpCheckboxCheckedChange)="setDocumentSelected(view.document.id, $event)"
                            [attr.aria-label]="'Selecionar ' + view.title"
                          >
                            <ng-icon name="heroCheck" size="13" aria-hidden="true" class="opacity-0 transition-opacity group-data-[checked]:opacity-100" />
                          </button>
                          <h3>{{ view.title }}</h3>
                        </div>
                      </div>

                      <div class="document-card-actions">
                        <button
                          appSwitch
                          class="status-toggle-card"
                          [attr.aria-label]="documentIsActive(view.document) ? 'Desativar documento' : 'Ativar documento'"
                          [ngpSwitchChecked]="documentIsActive(view.document)"
                          (ngpSwitchCheckedChange)="setDocumentActive(view.document, $event)"
                        >
                          <span class="status-toggle-track" aria-hidden="true">
                            <span appSwitchThumb></span>
                          </span>
                          <span>{{ documentIsActive(view.document) ? 'Ativo' : 'Inativo' }}</span>
                        </button>

                        <button
                          appButton
                          variant="ghost"
                          size="sm"
                          type="button"
                          [ngpMenuTrigger]="documentActionsMenu"
                          ngpMenuTriggerPlacement="bottom-end"
                          aria-label="Ações do documento"
                        >
                          <ng-icon name="heroEllipsisVertical" size="17" aria-hidden="true" />
                        </button>
                        <ng-template #documentActionsMenu>
                          <div appMenuPanel class="document-menu__panel">
                            <button appMenuItem type="button" (click)="startDocumentEdit(view.document)">
                              <span>Editar</span>
                              <ng-icon name="heroPencilSquare" size="15" aria-hidden="true" />
                            </button>
                            <button appMenuItem type="button" (click)="openDuplicateDialogForDocument(view.document)">
                              <span>Duplicar</span>
                              <ng-icon name="heroDocumentDuplicate" size="15" aria-hidden="true" />
                            </button>
                            <div appMenuSeparator></div>
                            <button appMenuItem tone="danger" type="button" (click)="deleteDocument(view.document)">
                              <span>Excluir</span>
                              <ng-icon name="heroTrash" size="15" aria-hidden="true" />
                            </button>
                          </div>
                        </ng-template>
                      </div>
                    </div>

                    @if (view.sections.length > 0) {
                      <dl class="document-sections">
                        @for (section of view.sections; track section.key) {
                          <div class="document-section">
                            <dt>{{ section.label }}</dt>
                            @if (section.kind === 'text') {
                              <dd>{{ section.value }}</dd>
                            } @else {
                              <dd [class.document-section__badges]="section.display === 'badges'">
                                @for (item of section.items; track item) {
                                  @if (section.display === 'badges') {
                                    <span appBadge tone="neutral" size="xs">{{ item }}</span>
                                  } @else {
                                    <span>{{ item }}</span>
                                  }
                                }
                              </dd>
                            }
                          </div>
                        }
                      </dl>
                    } @else {
                      <p class="document-preview">{{ view.preview }}</p>
                    }

                    <div class="document-footer-meta">
                      <button appUiRecordRowButton type="button" class="document-source-link" (click)="toggleSourceDetails(view.document.sourceId)">
                        <ng-icon name="heroFolderOpen" size="13" aria-hidden="true" />
                        {{ view.sourceName }}
                      </button>
                      <small>{{ formatDate(view.document.createdAt) }}</small>
                    </div>
                  </article>
                }
              </div>
            }
          </section>
        </div>

        <aside class="workspace-rail" aria-label="Operações da biblioteca">
          <section appUiPanelCard class="content-panel source-sidebar" aria-label="Fontes vinculadas">
            <div class="section-heading section-heading--compact">
              <div>
                <span appUiLabel class="uppercase">Fontes</span>
                <h2>Materiais</h2>
              </div>
              <button appButton variant="primary" size="sm" type="button" (click)="openSourceDialog()">
                <ng-icon name="heroPlus" size="15" aria-hidden="true" />
                Inserir
              </button>
            </div>

            @if (selectedSources().length === 0) {
              <app-ui-empty-state
                icon="heroCloudArrowUp"
                title="Nenhuma fonte vinculada"
                description="Insira uma fonte para alimentar esta biblioteca."
              />
            } @else {
              <div class="source-list">
                @for (source of selectedSources(); track source.id) {
                  <article appUiRecordRow [interactive]="false" class="source-card">
                    <button appUiRecordRowButton type="button" class="source-card__summary" (click)="toggleSourceDetails(source.id)">
                      <span
                        class="resource-icon"
                        [class.resource-icon--failed]="sourceProcessingState(source) === 'failed'"
                        [class.resource-icon--processing]="sourceProcessingState(source) === 'processing'"
                        [class.resource-icon--pending]="sourceProcessingState(source) === 'pending'"
                      >
                        @if (sourceProcessingState(source) === 'processing') {
                          <app-ui-spinner [size]="17" [stroke]="2" aria-hidden="true" />
                        } @else {
                          <ng-icon [name]="sourceStateIcon(source)" size="17" aria-hidden="true" />
                        }
                        @if (sourceProcessingState(source) === 'pending') {
                          <app-ui-pulse-dot class="resource-icon__ping" aria-hidden="true" />
                        }
                      </span>
                      <span class="min-w-0 flex-1">
                        <span class="block truncate text-sm font-semibold text-ink">{{ source.name }}</span>
                        <span appUiHint class="mt-1 block truncate">{{ sourceTypeLabel(source) }} · {{ sourceDetail(source) }}</span>
                      </span>
                      <ng-icon [name]="isSourceExpanded(source.id) ? 'heroChevronDown' : 'heroChevronRight'" size="15" aria-hidden="true" class="text-muted" />
                    </button>

                    @if (isSourceExpanded(source.id)) {
                      <div class="source-card__detail">
                        <div class="source-detail-grid">
                          <span>
                            <strong>Tipo</strong>
                            {{ sourceTypeLabel(source) }}
                          </span>
                          <span>
                            <strong>Tamanho</strong>
                            {{ fileSize(source.fileSizeBytes) }}
                          </span>
                        </div>

                        @if (source.tags.length > 0) {
                          <div class="tag-list">
                            @for (tag of source.tags; track tag) {
                              <span appBadge tone="neutral" size="xs">{{ tag }}</span>
                            }
                          </div>
                        }

                        <div class="source-card__actions">
                          <button appButton variant="ghost" size="sm" type="button" (click)="reprocessSource(source)" [disabled]="updatingSource()">
                            <ng-icon name="heroArrowPath" size="15" aria-hidden="true" />
                            Reprocessar
                          </button>
                          <button appButton variant="secondary" size="sm" type="button" (click)="startSourceUpdate(source)">
                            <ng-icon name="heroPencilSquare" size="15" aria-hidden="true" />
                            Editar fonte
                          </button>
                        </div>

                        @if (jobsForSource(source.id).length > 0) {
                          <div class="source-jobs">
                            @for (job of jobsForSource(source.id); track job.id) {
                              <div class="source-job-row" [class.source-job-row--failed]="job.status === 'failed'">
                                <span>{{ statusLabel(job.status) }}</span>
                                <small>{{ job.documentsCreated ?? 0 }} docs · {{ job.chunksCreated ?? 0 }} chunks</small>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </article>
                }
              </div>
            }
          </section>
        </aside>
      </section>
    </section>
  }

  @if (selectedDocumentCount() > 0) {
    <div appUiBulkActionBar role="region" aria-label="Ações em massa para documentos">
      <span appUiBulkActionBarCount>{{ selectedDocumentCount() }} selecionado(s)</span>
      <span appUiBulkActionBarSeparator></span>

      <div appUiBulkActionBarGroup>
        <button appUiBulkActionButton type="button" (click)="bulkActivateDocuments()">
          <ng-icon name="heroCheckCircle" size="15" aria-hidden="true" />
          Ativar
        </button>
        <button appUiBulkActionButton type="button" (click)="bulkDeactivateDocuments()">
          <ng-icon name="heroXCircle" size="15" aria-hidden="true" />
          Desativar
        </button>
        <button appUiBulkActionButton type="button" (click)="exportSelectedDocumentsCsv()">
          <ng-icon name="heroArrowDownTray" size="15" aria-hidden="true" />
          CSV
        </button>
        <button appUiBulkActionButton type="button" (click)="openDuplicateDialogForSelection()">
          <ng-icon name="heroDocumentDuplicate" size="15" aria-hidden="true" />
          Duplicar
        </button>
        <button appUiBulkActionButton tone="danger" type="button" (click)="deleteSelectedDocuments()">
          <ng-icon name="heroTrash" size="15" aria-hidden="true" />
          Excluir
        </button>
      </div>

      <span appUiBulkActionBarSeparator></span>
      <button appUiBulkActionButton iconOnly type="button" (click)="clearDocumentSelection()" aria-label="Limpar seleção">
        <ng-icon name="heroXMark" size="15" aria-hidden="true" />
      </button>
    </div>
  }

  @if (duplicateDialogOpen()) {
    <div appDialogOverlay>
      <section appDialog class="knowledge-dialog" aria-labelledby="duplicate-documents-title" [ngpDialogModal]="true">
        <div class="dialog-header">
          <div>
            <span appUiLabel class="uppercase">Duplicar</span>
            <h2 appDialogTitle id="duplicate-documents-title">Enviar para biblioteca</h2>
            <p appDialogDescription>{{ duplicateDialogDocumentIds().length }} documento(s) selecionado(s).</p>
          </div>
          <button appButton variant="ghost" size="sm" type="button" (click)="closeDuplicateDialog()" aria-label="Fechar">
            <ng-icon name="heroXMark" size="17" aria-hidden="true" />
          </button>
        </div>

        <div>
          <span appUiLabel class="mb-2 block uppercase" id="duplicate-target-label">Biblioteca de destino</span>
          <button
            appSelect
            type="button"
            aria-labelledby="duplicate-target-label"
            [ngpSelectValue]="duplicateTargetBaseId()"
            (ngpSelectValueChange)="setDuplicateTargetBase($event)"
            [ngpSelectDisabled]="duplicateTargetOptions().length === 0"
          >
            <span class="truncate">{{ duplicateTargetBaseName() }}</span>
            <div *ngpSelectPortal appSelectDropdown>
              @for (base of duplicateTargetOptions(); track base.id) {
                <div appSelectOption [ngpSelectOptionValue]="base.id">{{ base.name }}</div>
              }
            </div>
          </button>
        </div>

        <div class="form-actions">
          <button appButton variant="secondary" type="button" (click)="closeDuplicateDialog()">Cancelar</button>
          <button appButton variant="primary" type="button" (click)="duplicateDocuments()" [disabled]="!duplicateTargetBaseId()">Duplicar</button>
        </div>
      </section>
    </div>
  }

  @if (sourceDialogOpen()) {
    <div appDialogOverlay>
      <section appDialog class="knowledge-dialog knowledge-dialog--wide" aria-labelledby="source-dialog-title" [ngpDialogModal]="true">
        <div class="dialog-header">
          <div>
            <span appUiLabel class="uppercase">Nova fonte</span>
            <h2 appDialogTitle id="source-dialog-title">Inserir material</h2>
            <p appDialogDescription>Adicione uma fonte para gerar novos documentos nesta biblioteca.</p>
          </div>
          <button appButton variant="ghost" size="sm" type="button" (click)="closeSourceDialog()" aria-label="Fechar">
            <ng-icon name="heroXMark" size="17" aria-hidden="true" />
          </button>
        </div>

        <div class="dialog-toolbar">
          <div
            appToggleGroup
            ngpToggleGroupType="single"
            aria-label="Tipo de fonte"
            [ngpToggleGroupValue]="sourceModeValue()"
            (ngpToggleGroupValueChange)="setSourceModeValue($event)"
          >
            <button appToggleGroupItem tone="accent" ngpToggleGroupItemValue="url">
              <ng-icon name="heroLink" size="16" aria-hidden="true" />
              URL
            </button>
            <button appToggleGroupItem tone="accent" ngpToggleGroupItemValue="file">
              <ng-icon name="heroArrowUpTray" size="16" aria-hidden="true" />
              Arquivo
            </button>
            <button appToggleGroupItem tone="accent" ngpToggleGroupItemValue="manual">
              <ng-icon name="heroPencilSquare" size="16" aria-hidden="true" />
              Manual
            </button>
            <button appToggleGroupItem tone="accent" ngpToggleGroupItemValue="csv">
              <ng-icon name="heroTableCells" size="16" aria-hidden="true" />
              CSV
            </button>
          </div>

          <button appButton variant="ghost" size="sm" type="button" (click)="downloadCsvTemplate()">
            <ng-icon name="heroArrowDownTray" size="16" aria-hidden="true" />
            Template CSV
          </button>
        </div>

        <div class="form-grid">
          <label>
            <span appUiLabel class="mb-2 block uppercase">Nome da fonte</span>
            <input appInput type="text" [value]="sourceName()" (input)="setSignal(sourceName, $event)" placeholder="Ex.: Política de trocas" />
          </label>
          <label>
            <span appUiLabel class="mb-2 block uppercase">Tags</span>
            <input appInput type="text" [value]="sourceTags()" (input)="setSignal(sourceTags, $event)" placeholder="atendimento, trocas, lojas" />
          </label>

          @if (sourceMode() === 'url') {
            <label class="form-grid__wide">
              <span appUiLabel class="mb-2 block uppercase">URL</span>
              <input appInput type="url" [value]="sourceUrl()" (input)="setSignal(sourceUrl, $event)" placeholder="https://..." />
            </label>
          }

          @if (sourceMode() === 'file') {
            <app-ui-file-picker
              class="form-grid__wide"
              accept=".pdf,.docx,.txt,.md,.markdown,.csv,.xlsx"
              icon="heroDocumentArrowUp"
              label="Arquivo"
              hint="PDF, DOCX, TXT, Markdown, CSV ou XLSX"
              [fileName]="selectedFileName(sourceFile())"
              (fileChange)="setSourceFile($event)"
            />
          }

          @if (sourceMode() === 'manual') {
            <label class="form-grid__wide">
              <span appUiLabel class="mb-2 block uppercase">Conteúdo</span>
              <textarea
                appTextarea
                rows="8"
                [value]="sourceManualContent()"
                (input)="setSignal(sourceManualContent, $event)"
                placeholder="Cole o conteúdo que será salvo como fonte de texto."
              ></textarea>
            </label>
          }

          @if (sourceMode() === 'csv') {
            <app-ui-file-picker
              class="form-grid__wide"
              accept=".csv,text/csv"
              icon="heroTableCells"
              label="CSV"
              hint="Arquivo CSV com colunas compatíveis com o template"
              [fileName]="selectedFileName(sourceCsvFile())"
              (fileChange)="setSourceCsvFile($event)"
            />
          }
        </div>

        <div class="form-actions">
          <button appButton variant="secondary" type="button" (click)="closeSourceDialog()">Cancelar</button>
          <button appButton variant="primary" type="button" (click)="createSource()" [disabled]="savingSource() || !canCreateSource()">
            @if (savingSource()) {
              Salvando...
            } @else {
              Adicionar e processar
            }
          </button>
        </div>
      </section>
    </div>
  }

  @if (editingSource(); as source) {
    <div appDialogOverlay>
      <section appDialog class="knowledge-dialog knowledge-dialog--wide" aria-labelledby="source-update-title" [ngpDialogModal]="true">
        <div class="dialog-header">
          <div>
            <span appUiLabel class="uppercase">Fonte</span>
            <h2 appDialogTitle id="source-update-title">{{ source.name }}</h2>
            <p appDialogDescription>Atualize metadados ou substitua o material para reprocessar documentos.</p>
          </div>
          <button appButton variant="ghost" size="sm" type="button" (click)="cancelSourceUpdate()" aria-label="Fechar">
            <ng-icon name="heroXMark" size="17" aria-hidden="true" />
          </button>
        </div>

        <div class="form-grid">
          <label>
            <span appUiLabel class="mb-2 block uppercase">Nome</span>
            <input appInput type="text" [value]="updateSourceName()" (input)="setSignal(updateSourceName, $event)" />
          </label>
          <label>
            <span appUiLabel class="mb-2 block uppercase">Tags</span>
            <input appInput type="text" [value]="updateSourceTags()" (input)="setSignal(updateSourceTags, $event)" />
          </label>

          @if (source.sourceType === 'url') {
            <label class="form-grid__wide">
              <span appUiLabel class="mb-2 block uppercase">URL</span>
              <input appInput type="url" [value]="updateSourceUrl()" (input)="setSignal(updateSourceUrl, $event)" />
            </label>
          } @else if (source.sourceType === 'upload') {
            <div class="form-grid__wide">
              <div
                appToggleGroup
                ngpToggleGroupType="single"
                aria-label="Substituição da fonte"
                [ngpToggleGroupValue]="sourceUpdateModeValue()"
                (ngpToggleGroupValueChange)="setSourceUpdateModeValue($event)"
              >
                <button appToggleGroupItem ngpToggleGroupItemValue="metadata">Metadados</button>
                <button appToggleGroupItem ngpToggleGroupItemValue="file">
                  <ng-icon name="heroArrowUpTray" size="16" aria-hidden="true" />
                  Arquivo
                </button>
                <button appToggleGroupItem ngpToggleGroupItemValue="manual">
                  <ng-icon name="heroPencilSquare" size="16" aria-hidden="true" />
                  Manual
                </button>
                <button appToggleGroupItem ngpToggleGroupItemValue="csv">
                  <ng-icon name="heroTableCells" size="16" aria-hidden="true" />
                  CSV
                </button>
              </div>
            </div>

            @if (sourceUpdateMode() === 'file') {
              <app-ui-file-picker
                class="form-grid__wide"
                accept=".pdf,.docx,.txt,.md,.markdown,.csv,.xlsx"
                icon="heroDocumentArrowUp"
                label="Novo arquivo"
                hint="Substitui o material atual e reprocessa a fonte"
                [fileName]="selectedFileName(updateFile())"
                (fileChange)="setUpdateFile($event)"
              />
            }

            @if (sourceUpdateMode() === 'manual') {
              <label class="form-grid__wide">
                <span appUiLabel class="mb-2 block uppercase">Novo conteúdo</span>
                <textarea appTextarea rows="8" [value]="updateManualContent()" (input)="setSignal(updateManualContent, $event)"></textarea>
              </label>
            }

            @if (sourceUpdateMode() === 'csv') {
              <app-ui-file-picker
                class="form-grid__wide"
                accept=".csv,text/csv"
                icon="heroTableCells"
                label="Novo CSV"
                hint="Substitui o material atual usando o template CSV"
                [fileName]="selectedFileName(updateCsvFile())"
                (fileChange)="setUpdateCsvFile($event)"
              />
            }
          }
        </div>

        <div class="form-actions">
          <button appButton variant="secondary" type="button" (click)="reprocessSource(source)" [disabled]="updatingSource()">Reprocessar</button>
          <button appButton variant="primary" type="button" (click)="updateCurrentSource()" [disabled]="updatingSource() || !canUpdateSource()">
            @if (updatingSource()) {
              Atualizando...
            } @else {
              Atualizar e reprocessar
            }
          </button>
        </div>
      </section>
    </div>
  }

  @if (editingDocumentContent(); as document) {
    <div appDialogOverlay>
      <section appDialog class="knowledge-dialog knowledge-dialog--wide" aria-labelledby="document-edit-title" [ngpDialogModal]="true">
        <div class="dialog-header">
          <div>
            <span appUiLabel class="uppercase">Documento</span>
            <h2 appDialogTitle id="document-edit-title">Editar conteúdo</h2>
            <p appDialogDescription>{{ sourceForDocument(document) }}</p>
          </div>
          <button appButton variant="ghost" size="sm" type="button" (click)="closeDocumentEdit()" aria-label="Fechar">
            <ng-icon name="heroXMark" size="17" aria-hidden="true" />
          </button>
        </div>

        <div class="form-grid form-grid--single">
          <label>
            <span appUiLabel class="mb-2 block uppercase">Título</span>
            <input appInput type="text" [value]="documentEditTitle()" (input)="setSignal(documentEditTitle, $event)" />
          </label>

          @for (section of documentEditSections(); track section.key) {
            <label>
              <span appUiLabel class="mb-2 block uppercase">{{ section.label }}</span>
              <textarea
                appTextarea
                [rows]="section.kind === 'text' ? 5 : 4"
                [value]="section.value"
                (input)="setDocumentEditSectionValue(section.key, $event)"
                [placeholder]="section.kind === 'text' ? 'Conteúdo da seção' : 'Um item por linha'"
              ></textarea>
            </label>
          }
        </div>

        <div class="form-actions">
          <button appButton variant="secondary" type="button" (click)="closeDocumentEdit()">Cancelar</button>
          <button appButton variant="primary" type="button" (click)="saveDocumentEdit()" [disabled]="!documentEditTitle().trim()">Salvar</button>
        </div>
      </section>
    </div>
  }
</main>
